import qs from 'qs'
import { axios } from './axios'
import { PaginationRequestParams } from './types'
import { ChainProtocol } from '@archax/shared-types'

interface GetRequestBaseParams {
  sort?: {
    field: string
    direction: 'asc' | 'desc'
  } | null
}
interface GetRequestParams extends GetRequestBaseParams, PaginationRequestParams {}

export const getPayoutsUrl = (params: GetRequestBaseParams) => {
  const { sort, ...rest } = params
  const queryObj = { ...rest, ...(sort && { sort: `${sort.field},${sort.direction}` }) }
  const querystring = qs.stringify(queryObj, { indices: false })
  return `/payout?${querystring}`
}

export async function getPayouts(params: GetRequestParams) {
  const url = getPayoutsUrl(params)
  const result = await axios.get(url)
  return result
}

export async function getAvailablePayoutTokensByProtocol(protocol: ChainProtocol) {
  const result = await axios.get(`/payout/available-payout-tokens/${protocol}`)
  return result
}

export async function getAvailableEligibilityTokensByProtocol(protocol: ChainProtocol) {
  const result = await axios.get(`/payout/available-eligibility-tokens/${protocol}`)
  return result
}

export async function getPayoutDetailsById(payoutContractId: string) {
  const result = await axios.get(`/payout/${payoutContractId}`)
  return result
}

export const getPayoutHistoryUrl = (payoutContractId: string, params: GetRequestBaseParams) => {
  const { sort, ...rest } = params
  const queryObj = { ...rest, ...(sort && { sort: `${sort.field},${sort.direction}` }) }
  const querystring = qs.stringify(queryObj, { indices: false })
  return `/payout/${payoutContractId}/history?${querystring}`
}

export const getPayoutHistory = async (payoutContractId: string, params: GetRequestParams) => {
  const url = getPayoutHistoryUrl(payoutContractId, params)
  const result = await axios.get(url)
  return result
}

export const getPayoutWhitelistUrl = (payoutContractId: string, params: GetRequestBaseParams) => {
  const { sort, ...rest } = params
  const queryObj = { ...rest, ...(sort && { sort: `${sort.field},${sort.direction}` }) }
  const querystring = qs.stringify(queryObj, { indices: false })
  return `/payout/${payoutContractId}/whitelist?${querystring}`
}
export const getPayoutWhitelist = async (payoutContractId: string, params: GetRequestParams) => {
  const url = getPayoutWhitelistUrl(payoutContractId, params)
  const result = await axios.get(url)
  return result
}

export async function getPayoutGrantableAddresses(payoutContractId: string, traderId: string) {
  const result = await axios.get(`/payout/${payoutContractId}/grantable-addresses/${traderId}`)
  return result
}
